import React, { useCallback, useState } from 'react';
import Slider from 'react-slick';
import cn from 'classnames';

import ExternalLink from 'components/generic/ExternalLink.component';
import Space from 'components/generic/Space.component';
import S from 'constants/string.const';

import { trackEvent } from 'tracking/actions';

import CN from './SlickSlider.module.scss';

const LINK_TIPPING = 'https://www.getslick.com/tipping';
const LINK_REF = 'https://www.getslick.com/referral';

const SlickSlider = () => {
  const [activeSlide, setActiveSlide] = useState(0);

  const handleAfterChange = useCallback((index) => {
    setActiveSlide(index);
  }, []);

  const customPaging = useCallback(
    (index) => (
      <span
        className={cn({
          [CN.dot]: true,
          [CN.active]: index === activeSlide,
        })}
        onClick={() => handleAfterChange(index)}
      />
    ),
    [activeSlide, handleAfterChange],
  );

  return (
    <Slider
      dots
      dotsClass={CN.slickDots}
      customPaging={customPaging}
      arrows={false}
      infinite
      fade
      speed={1000}
      autoplay
      autoplaySpeed={4000}
      slidesToShow={1}
      slidesToScroll={1}
      afterChange={handleAfterChange}
      className={cn({
        [CN.component]: true,
      })}
    >
      <div
        data-bem="SlickSlider__email"
        className={cn({
          [CN.slideImage]: true,
          [CN.imageEmail]: true,
        })}
      >
        <div className={CN.container}>
          <div className={CN.description}>
            <div className={CN.subTitle}>
              <div className={CN.text}>{S.email} Beautiful emails - Coming soon!</div>
            </div>
            <div className={CN.title}>
              Email marketing <div className={CN.textWave}>made easy</div>
            </div>
          </div>
        </div>
      </div>

      <div
        data-bem="SlickSlider__reff"
        className={cn({
          [CN.slideImage]: true,
          [CN.imageReff]: true,
        })}
      >
        <div className={CN.container}>
          <div className={CN.description}>
            <div className={CN.subTitle}>
              <span className={CN.emoji}>{S.womanRaisingHand}</span>
              <div className={CN.text}>Referrals</div>
            </div>
            <div className={CN.title}>
              Refer Slick <Space>and</Space>
              {/* NOTE: Currency is hardcoded on the login slider because CurrencySign depends on salon data, 
              which is not available before authentication.*/}
              <div className={CN.textWave}>earn £250</div>
            </div>
            <div className={CN.linkContainer}>
              <ExternalLink variant="tertiaryLight" link={LINK_REF} onClick={() => trackEvent('login_vouchers')}>
                <div className={CN.link}>Refer a friend</div>
              </ExternalLink>
              <span className={CN.tAndC}>*Terms and Conditions apply</span>
            </div>
          </div>
        </div>
      </div>

      <div
        data-bem="SlickSlider__tipping"
        className={cn({
          [CN.slideImage]: true,
          [CN.imageTipping]: true,
        })}
      >
        <div className={CN.container}>
          <div className={CN.description}>
            <div className={CN.subTitle}>
              <div className={CN.text}>{S.poundBanknote} Tipping</div>
            </div>
            <div className={CN.title}>
              Boost staff tips <div className={CN.textWave}>by 50%</div>
            </div>
            <div className={CN.linkContainer}>
              <ExternalLink variant="tertiaryLight" link={LINK_TIPPING} onClick={() => trackEvent('login_education')}>
                <div className={CN.link}>LEARN MORE</div>
              </ExternalLink>
            </div>
          </div>
        </div>
      </div>
    </Slider>
  );
};

export default SlickSlider;
